/**
 * @module components/LegendSetting/LegendPosition
 * @description 图例位置选择器 — ChartSettingsContext + useSettingState
 */

import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';
import { useSettingState } from '../../context';

/** 图例位置枚举 — 与 @customComp/Chart/chartConfigs/legend/enums 保持一致 */
enum LegendPositionEnum {
  Below = 'below',
  Above = 'above',
  Hide = 'hide',
}

/**
 * LegendPosition — 图例展示位置配置
 *
 * 选项：下方 / 上方 / 隐藏
 */
const LegendPosition: React.FC = () => {
  const { formatMessage } = useIntl();
  const { value, setValue } = useSettingState('legend_position');

  const options = useMemo(
    () => [
      {
        value: LegendPositionEnum.Below,
        text: formatMessage({ id: 'dbl_chart_legend_position_below' }),
      },
      {
        value: LegendPositionEnum.Above,
        text: formatMessage({ id: 'dbl_chart_legend_position_above' }),
      },
      {
        value: LegendPositionEnum.Hide,
        text: formatMessage({ id: 'dbl_chart_legend_position_hide' }),
      },
    ],
    [formatMessage],
  );

  const handleChange = useCallback(
    (newValue: string) => {
      setValue(newValue);
    },
    [setValue],
  );

  return (
    <div className="dbl-chart-setting-row">
      <span className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_legend_position' })}
      </span>
      <Select
        className="dbl-sort-by-panel__select"
        appearance="button"
        listWidth={232}
        matchButtonWidth
        value={value}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
};

export default React.memo(LegendPosition);
